import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { provideAnimations } from '@angular/platform-browser/animations';
import { AppModule } from './app/app.module';
import { applyStoredRebrandBodyClass } from './app/core/helpers/apply-rebrand-body-class';
import { registerElements } from './app/core/helpers/register-elements';
import { SpinnerComponent } from './app/project/components/spinner/spinner.component';
import { environment } from './environments/environment';
import { forceAuthHeadersOnXMLHttpRequests } from './app/core/helpers/authorise-xml-http-request';

if (environment.production) {
  enableProdMode();
}

applyStoredRebrandBodyClass();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    providers: [provideAnimations()],
  })
  .then((moduleRef) => {
    const injector = moduleRef.injector;

    registerElements(SpinnerComponent, 'pp-spinner-standalone', injector);
  })
  .catch((err) => console.log(err));

forceAuthHeadersOnXMLHttpRequests();
